"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ValidationErrorTypeEnum;
(function (ValidationErrorTypeEnum) {
    ValidationErrorTypeEnum["Unknown"] = "unknown";
    ValidationErrorTypeEnum["Unplanned"] = "unplanned";
    ValidationErrorTypeEnum["MissingRequired"] = "missing_required";
    ValidationErrorTypeEnum["InvalidValue"] = "invalid_value";
})(ValidationErrorTypeEnum = exports.ValidationErrorTypeEnum || (exports.ValidationErrorTypeEnum = {}));
var SchemaKeywordErrorTypeEnum;
(function (SchemaKeywordErrorTypeEnum) {
    SchemaKeywordErrorTypeEnum["AdditionalItems"] = "additionalItems";
    SchemaKeywordErrorTypeEnum["AdditionalProperties"] = "additionalProperties";
    SchemaKeywordErrorTypeEnum["Const"] = "const";
    SchemaKeywordErrorTypeEnum["Dependencies"] = "dependencies";
    SchemaKeywordErrorTypeEnum["Enum"] = "enum";
    SchemaKeywordErrorTypeEnum["ExclusiveMaximum"] = "exclusiveMaximum";
    SchemaKeywordErrorTypeEnum["ExclusiveMinimum"] = "exclusiveMinimum";
    SchemaKeywordErrorTypeEnum["Format"] = "format";
    SchemaKeywordErrorTypeEnum["Maximum"] = "maximum";
    SchemaKeywordErrorTypeEnum["MaxLength"] = "maxLength";
    SchemaKeywordErrorTypeEnum["Minimum"] = "minimum";
    SchemaKeywordErrorTypeEnum["MinLength"] = "minLength";
    SchemaKeywordErrorTypeEnum["MultipleOf"] = "multipleOf";
    SchemaKeywordErrorTypeEnum["Pattern"] = "pattern";
    SchemaKeywordErrorTypeEnum["PatternProperties"] = "patternProperties";
    SchemaKeywordErrorTypeEnum["Required"] = "required";
    SchemaKeywordErrorTypeEnum["Type"] = "type";
})(SchemaKeywordErrorTypeEnum = exports.SchemaKeywordErrorTypeEnum || (exports.SchemaKeywordErrorTypeEnum = {}));
